const KEY = 'meto_banner_chat_state'

export function saveBannerChatState(state) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({
      curId: state.curId,
      history: state.history,
      loading: state.loading,
      buildingMessage: state.buildingMessage,
      isSendingMessage: state.isSendingMessage,
      hasMoreMessages: state.hasMoreMessages,
      savedAt: Date.now(),
    }))
  } catch (e) {
    /* ignore quota / private mode */
  }
}

export function loadBannerChatState() {
  try {
    const raw = sessionStorage.getItem(KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function clearBannerChatState() {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
}
